import { Trans, withI18n } from '@lingui/react'
import { bool, object, string } from 'prop-types'

import { OFFER_TYPE_MIRAKL, OFFER_TYPE_SAE } from 'shared/consts/marketplace'
import SellerModal from 'views/components/organisms/SellerModal'
import { SELLER_MODAL_ID } from 'views/components/organisms/SellerModal/names'
import { getSellerModalHook } from 'views/containers/browser/SellerModalContainer/clientsideHook'

const SellerBox = ({
  sellerName,
  sellerId,
  offerType,
  cssBoxClasses,
  embedSellerModal,
}) => {
  const isPartnerOffer = offerType === OFFER_TYPE_MIRAKL

  const cssClasses = Object.assign(
    {
      textAlign: 'u-text-align--center@medium',
      padding: 'u-padding-large',
      backgroundColor: 'u-background-color--greyLight',
    },
    cssBoxClasses
  )
  const isNotSaeOffer = offerType !== OFFER_TYPE_SAE
  const partnerText = (
    <>
      <div className={`a-p8 u-font-weight--bold ${cssClasses.textAlign}`}>
        <Trans id="message.soldAndShipped.partner" />
        <span
          data-a11y-dialog-show={SELLER_MODAL_ID}
          data-clientside-hook={getSellerModalHook(sellerId)}
          className="a-link a-link--no-underline u-padding-xx-small--left"
          data-qa-id="seller-name"
          data-target="seller-box"
        >
          {sellerName}
        </span>
      </div>

      {embedSellerModal && <SellerModal />}
    </>
  )
  const saeText = (
    <div className={`a-p8 u-font-weight--bold ${cssClasses.textAlign}`}>
      <Trans id="message.soldAndShipped.shopApotheke" />
    </div>
  )

  return (
    isNotSaeOffer && (
      <div
        className={`a-box ${cssClasses.backgroundColor} u-margin-small--top ${cssClasses.padding} u-padding@small-tiny u-text-align--center@small-tiny o-SellerBox`}
      >
        {isPartnerOffer ? partnerText : saeText}
      </div>
    )
  )
}

SellerBox.propTypes = {
  sellerId: string.isRequired,
  sellerName: string.isRequired,
  offerType: string.isRequired,
  cssBoxClasses: object,
  embedSellerModal: bool,
}

SellerBox.defaultProps = {
  embedSellerModal: false,
}

export default withI18n()(SellerBox)
